import React from "react";
import { connect } from "react-redux";
import { withTranslation} from "react-i18next";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from '@material-ui/icons/Cancel';
import ChatIcon from '@material-ui/icons/Chat';
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import { green, amber} from '@material-ui/core/colors';
import { SwipeableList, SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import Services from "../../api/api";
import { auth } from "../../service/firebase";
import { signup, signin, logout, signInAnonymously,logError } from "../../helpers/auth";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

function ServicesList(props) {
  
  // const swipeLeftOptions = name => ({
  //   content: <div label="Confirm" position="right" class="self-conform-bg">Satisfied</div>,
  //   action: () => itemSwipedLeft(`Swipe left action on "${name}"`)
  // });

  // const swipeRightOptions = name => ({
  //   content: <div label="Not Confirm" position="right" class="self-conform-bg self-not-conform-bg">Not Satisfied</div>,
  //   action: () => itemSwipedRight(`Swipe right action on "${name}"`)
  // });

  const classes = useStyles();
  let history = useHistory();
  const { t } = props;
  const { templateID } = props;
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};
  // let [icon] = useState('')

  function handleChatClick() {
    props.caseobj['chatType'] = 'peer';
    let user = auth().currentUser
    console.log("user>>", user);
    if (user != null) {
      history.push({
        pathname: "/layout/ServicesChatWindow",
        state: {
          caseObj: props.caseobj,
          userObj: user,
          chatType: 'peer'
        }
      });
    } else {
      var loggedinnameonly = localStorage.getItem("loggedinname");
      var loggedinname = localStorage.getItem("loggedinname");
      if(loggedinname){
        // create a valid email for firebase login if user is using id
        if(loggedinname.indexOf('@') == -1){
          loggedinname = loggedinname + '@myrights.com';
          if(loggedinname.indexOf(' ') != -1){
            loggedinname = loggedinname.split(' ').join('_');
          }
        }
        signup(loggedinname, localStorage.getItem("loggedinpass"))
          .then((userCredential) => {
            console.log("userCredential", userCredential)
            // Signed in 
            var user = userCredential.user;
            user.updateProfile({
              displayName: loggedinnameonly,
            })
            gotoChat(user);
            // ...
          })
          .catch((error) => {
            console.log("error", error)
            signin(loggedinname, localStorage.getItem("loggedinpass"))
              .then((userCredential) => {
                console.log("userCredential", userCredential)
                // Signed in 
                var user = userCredential.user;
                user.updateProfile({
                  displayName: loggedinnameonly,
                })
                gotoChat(user);
                // ...
              })
              .catch((error) => {
                console.log("error", error)
                var errorCode = error.code;
                var errorMessage = error.message;
                // ..
              });
          });
      }else{
        signInAnonymously().then((res) => {
          auth().onAuthStateChanged((user) => {
            console.log("onAuthStateChanged>>", user);
            if (user) {
              gotoChat(user);
            } else {
              console.log("error>>", user);
            }
          });
        })
          .catch((err) => console.log("err>>>", err));
      }
    }

  }

  function gotoChat(user) {
    props.caseobj['chatType'] = 'peer';
    console.log("user>>", user);
    history.push({
      pathname: "/layout/ServicesChatWindow",
      state: {
        caseObj: props.caseobj,
        userObj: user,
        chatType: 'peer'
      }
    });
  }



  // async function signInAnonymously() {
  //   try {
  //      signInAnonymously().then((res) => {
  //       console.log('uatu>>', res)
  //         auth().onAuthStateChanged((user) => {
  //           console.log('onAuthStateChanged>>', user)
  //           if (user) {
  //             gotoChat(user);
  //           } else {
  //             console.log("error>>", user);
  //           }
  //         });
  //       }).catch((error) => {
  //         console.log("error>>", error);
  //       })
  //   } catch (error) {
  //     console.log("error>>", error);
  //   }
  // }

  let icon = <HourglassEmptyIcon />;
  // console.log("props.casetype>>", props, props.caseobj.caseId, props.caseobj.createdDate);
  if (props.casetype) {
    switch (props.casetype) {
      case "open":
        icon = <HourglassEmptyIcon style={{ color: amber[500] }} />;
        break;
      case "resolved":
        icon = <CheckCircleIcon style={{ color: green[500] }} />;
        break;
      case "confirmed":
        icon = <CheckCircleIcon style={{ color: green[500] }} />;
        break;
      case "declined":
        icon = <CancelIcon color="secondary" />;
        break;
      case "offline":
        icon = <PermScanWifiIcon  />;
        break;
      default:
        break;
    }
  }

  function formatTime(timestamp) {
    const d = new Date(timestamp);
    const time = `${d.getDate()}/${d.getMonth() + 1
      }/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    return time;
  }

  function itemSwipedLeft() {
    console.log("item swiped left", props);
    var params = {
      communityId: props.communityuid,
      caseSetId: props.caseobj.caseId,
      caseStatus: {
        "caseResponderEmail": "",
        "caseResponderId": JSON.parse(localStorage.getItem("obj")).userId,
        "caseResponderRoleType": JSON.parse(localStorage.getItem("obj")).roleType,
        "caseStatusResponse": {
          "comments": "Test Comment"
        },
        id: 6,
        status: "Confirmed"
      }
    };
    console.log("getMenuList>>", params);
    Services.ChangeCaseStatusForService(params).then((res) => {
      try{
        if (res.data.status == 200) {
          console.log("res::", res);
          props.updateCaseList()
        }
      }catch(err){
        console.log("err::", err)
        var errorObj = {
          component: 'ReportList',
          method: 'itemSwipedLeft',
          error: err
        }
        logError(errorObj);
      }
    });
  }
  function itemSwipedRight() {
    console.log("item swiped right");
    var params = {
      communityId: props.communityuid,
      caseSetId: props.caseobj.caseId,
      caseStatus: {
        "caseResponderEmail": "",
        "caseResponderId": JSON.parse(localStorage.getItem("obj")).userId,
        "caseResponderRoleType": JSON.parse(localStorage.getItem("obj")).roleType,
        "caseStatusResponse": {
          "comments": "Test Comment"
        },
        id: 7,
        status: "NotConfirmed"
      }
    };
    console.log("getMenuList>>", params);

    Services.ChangeCaseStatusForService(params).then((res) => {
      try{
        if (res.data.status == 200) {
          console.log("res::", res);
          props.updateCaseList()
        }
      }catch(err){
        console.log("err::", err)
        var errorObj = {
          component: 'ReportList',
          method: 'itemSwipedRight',
          error: err
        }
        logError(errorObj);
      }
    });
  }


  function handleClick() {
    if(props.casetype != 'offline') {
      props.caseobj['casetype'] = props.casetype
      history.push({
        pathname: "/layout/ServicesCasePreview",
        state: props.caseobj,
      });
    } else {
      props.caseobj['casetype'] = props.casetype
      history.push({
        pathname: "/layout/ServiceForm",
        state: props.caseobj,
      });
    }
  }

  return (
    <Grid
      container
      spacing={3}
      className="gridcontainer chatuserlistdiv borderbottomgrey"
    >

      <SwipeableList>
        <SwipeableListItem
          // swipeLeft={props.casetype == 'resolved' || props.casetype == 'notconfirmed' ? swipeLeftOptions('Item with both swipes') : ''}
          // swipeRight={props.casetype == 'resolved' || props.casetype == 'confirmed' ? swipeRightOptions('Item with both swipes') : ''}
        >
          <Grid item xs={2} className="zero">
            <p className="zero  text-center responselisticon">
              <LockOpenIcon  style={colorStyles} />
            </p>
          </Grid>
          <Grid item xs={6} className="zero"  onClick={handleClick}>
            <p className="zero  chatusername"  style={colorStyles}>
              {props.caseobj.caseId} : {props.caseobj.serviceName}
            </p>
            <p className="zero color-yellow chatdistance">
              {props.casetype != "offline" ? formatTime(props.caseobj.createdDate) : props.caseobj.offlineDate}
            </p>
          </Grid>
          {
            props.casetype != "offline" ? (
              <>
                <Grid item xs={2} className="zero text-center">
                  <p className="text-center unreadmsgicon reportmiddle">
                    <span className="color-green display-flex">{icon}</span>
                    {/* <Badge showZero badgeContent={0} color="primary">
                  <MailIcon style={{ color: grey[500] }} />
                </Badge> */}
                  </p>
                  <span class="case-status-label">{t(props.casetype)}</span>
                </Grid>
                <Grid item xs={2} className="zero text-center">
                  <span class="case-status-label icon" onClick={() => handleChatClick()}><ChatIcon  style={colorStyles}></ChatIcon></span>
                </Grid>
              </>
            ) : (
              <>
              <Grid item xs={2} className="zero"></Grid>
              <Grid item xs={2} className="zero">
              <p className="text-center unreadmsgicon reportmiddle">
                <span className="color-green display-flex">{icon}</span>
              </p>
              <span class="case-status-label">{t(props.casetype)}</span>
            </Grid>
            </>
            )
          }

        </SwipeableListItem>
      </SwipeableList>
    </Grid>

  );
}


function mapStateToProps(state) {
  return { 
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: state.storeState.communityId,
    componentbgcolor: state.storeState.componentbgcolor 
  };
}

export default connect(mapStateToProps)(withTranslation()(ServicesList));